"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELP_REFERENCE_FIELDS_PAGE = void 0;
var HELP_REFERENCE_FIELDS_PAGE = exports.HELP_REFERENCE_FIELDS_PAGE = '/docs/reference-fields';
//# sourceMappingURL=path.js.map